export const PANEL_ID = 'make-text-editable-loading-panel';
export const MODAL_BORDER_RADIUS = 20;
